
import Vue, { PropType } from 'vue'
import type { WithRefs } from 'vue-typed-refs'

import { WithProperties } from '@/types'

import WeveDraggable from '../WeveDraggable/WeveDraggable'
import { SidebarEntity } from './Sidebar.types'
import store from './Sidebar.store'

type Refs = {
  list: HTMLUListElement
}

export default (
  Vue as WithRefs<Refs, WithProperties<{ wd: WeveDraggable | null }>>
).extend({
  name: 'SidebarList',
  props: {
    draggable: {
      type: Boolean,
      default: true,
    },
    entity: {
      type: String as PropType<SidebarEntity>,
      required: true,
      validator: (val: SidebarEntity) =>
        Object.values(SidebarEntity).includes(val),
    },
  },
  created() {
    this.wd = null
  },
  mounted() {
    if (this.draggable) {
      this.wd = new WeveDraggable(this.$refs.list, {
        sort: false,
        onDragStart: (e) => {
          store.isDragging = true
          if (e.dataTransfer !== null) {
            e.dataTransfer.setData('entity', this.entity)
          }
        },
        onDragEnd: () => {
          store.isDragging = false
        },
      })
    }
  },
  beforeDestroy() {
    if (this.wd !== null) {
      this.wd.destroy()
    }
  },
  render(h) {
    return h(
      'ul',
      {
        ref: 'list',
        staticClass: 'sidebar-list py-2 pl-0 my-0 list-none',
      },
      this.$slots.default
    )
  },
})
